import { DialogContent, DialogOverlay } from '@reach/dialog';
import '@reach/dialog/styles.css';
import { Button, ButtonGroup, Text } from 'components/ui';
import { FC } from 'react';
import styled from 'styled-components';
import { ReactComponent as FilterIcon } from '../../images/filter.svg';
import { ReactComponent as CloseIcon } from './close.svg';

export interface FilterDialogProps {
  onClose?: () => void;
  onClear?: () => void;
}

const Overlay = styled(DialogOverlay)`
  z-index: 5;
`;

const Content = styled(DialogContent)`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  height: 100%;
`;

const Footer = styled(ButtonGroup)`
  position: relative;
  justify-content: center;
  padding: var(--space-2);
  box-shadow: 0 -1px 6px 0 rgba(0, 0, 0, 0.15);
`;

const InnerContent = styled.div`
  padding: var(--space-2);
  overflow: auto;
`;

const Header = styled.div`
  position: relative;
  display: flex;
  padding: var(--space-2);
  text-transform: uppercase;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
`;

const Title = styled(Text)`
  display: flex;
  align-items: center;
`;

const FilterIconStyled = styled(FilterIcon)`
  display: block;
  width: 24px;
  height: 24px;
  margin-right: var(--space-1);
`;

const CloseButton = styled.button`
  position: relative;
  margin-left: auto;

  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 32px;
    height: 32px;
    background-color: transparent;
    transform: translate(-50%, -50%);
    content: '';
  }
`;

const FilterDialog: FC<FilterDialogProps> = ({
  children,
  onClose,
  onClear,
}) => {
  return (
    <Overlay>
      <Content aria-labelledby='#dialog-heading'>
        <Wrapper>
          <Header>
            <Title fontWeight='bold'>
              <FilterIconStyled /> Filter
            </Title>
            <CloseButton aria-label='close' onClick={onClose}>
              <CloseIcon />
            </CloseButton>
          </Header>
          <InnerContent>{children}</InnerContent>
          <Footer>
            <Button variant='outline' onClick={onClear}>
              Clear
            </Button>
            <Button onClick={onClose}>Apply</Button>
          </Footer>
        </Wrapper>
      </Content>
    </Overlay>
  );
};

export default FilterDialog;
